const ACTIVITY_EVENTS: readonly string[] = [
	'mousedown',
	'keydown',
	'scroll',
	'touchstart',
	'pointermove',
] as const;

const THROTTLE_MS = 5_000;

let lastActivityTime: number = Date.now();
let initialized = false;
let throttleTimer: ReturnType<typeof setTimeout> | null = null;

function handleActivity(): void {
	if (throttleTimer !== null) return;
	lastActivityTime = Date.now();
	throttleTimer = setTimeout(() => {
		throttleTimer = null;
	}, THROTTLE_MS);
}

/**
 * Attach DOM listeners. Idempotent — safe to call multiple times.
 */
export function initActivityTracker(): void {
	if (initialized) return;
	for (const event of ACTIVITY_EVENTS) {
		window.addEventListener(event, handleActivity, {
			passive: true,
			capture: true,
		});
	}
	initialized = true;
}

/**
 * Remove DOM listeners.
 */
export function destroyActivityTracker(): void {
	if (!initialized) return;
	for (const event of ACTIVITY_EVENTS) {
		window.removeEventListener(event, handleActivity, { capture: true });
	}
	if (throttleTimer !== null) {
		clearTimeout(throttleTimer);
		throttleTimer = null;
	}
	initialized = false;
}

/**
 * Milliseconds since last user interaction.
 */
export function getIdleDurationMs(): number {
	return Date.now() - lastActivityTime;
}

/**
 * Manually mark activity (e.g. user clicks "Stay signed in").
 */
export function recordActivity(): void {
	lastActivityTime = Date.now();
}
